import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { forwardRefAndName } from "../../../../lib/forwardRefAndName";
import { BaseIcon } from "../../BaseIcon";
export var PictureIcon24Regular = forwardRefAndName('PictureIcon24Regular', function (props, ref) {
  return /*#__PURE__*/(
    React.createElement(BaseIcon, _extends({
      ref: ref,
      viewBoxSize: 24
    }, props), /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7 8.37512C7 7.06344 8.06332 6.00012 9.375 6.00012C10.6867 6.00012 11.75 7.06344 11.75 8.37512C11.75 9.68679 10.6867 10.7501 9.375 10.7501C8.06332 10.7501 7 9.68679 7 8.37512ZM9.375 7.50012C8.89175 7.50012 8.5 7.89187 8.5 8.37512C8.5 8.85837 8.89175 9.25012 9.375 9.25012C9.85824 9.25012 10.25 8.85837 10.25 8.37512C10.25 7.89187 9.85824 7.50012 9.375 7.50012Z"
    }), /*#__PURE__*/
    React.createElement("path", {
      d: "M12.6599 13.2563C13.0993 12.8169 13.8116 12.8169 14.2509 13.2563L16.0631 15.0684C16.356 15.3613 16.8309 15.3613 17.1237 15.0684C17.4166 14.7755 17.4166 14.3007 17.1237 14.0078L15.3116 12.1956C14.2865 11.1705 12.6244 11.1705 11.5993 12.1956L7.21967 16.5752C6.92677 16.8681 6.92677 17.343 7.21967 17.6359C7.51256 17.9288 7.98743 17.9288 8.28033 17.6359L12.6599 13.2563Z"
    }), /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.25 6C4.25 3.92893 5.92893 2.25 8 2.25H13.2564C13.9858 2.25 14.6853 2.53973 15.201 3.05546L18.9445 6.79902C19.4603 7.31475 19.75 8.01422 19.75 8.74357V18C19.75 20.0711 18.0711 21.75 16 21.75H8C5.92893 21.75 4.25 20.0711 4.25 18V6ZM8 3.75C6.75736 3.75 5.75 4.75736 5.75 6V18C5.75 19.2426 6.75736 20.25 8 20.25H16C17.2426 20.25 18.25 19.2426 18.25 18V8.74357C18.25 8.41205 18.1183 8.0941 17.8839 7.85968L14.1403 4.11612C13.9059 3.8817 13.588 3.75 13.2564 3.75H8Z"
    }))
  );
});